.attention-icon {
  --svg-symbol-color: var(--ui-color-base);
  --svg-success-color: var(--ui-color-success);
  --svg-warning-color: var(--ui-color-warning);
  --svg-error-color: var(--ui-color-error);
  --svg-info-color: var(--ui-color-info);
  --size: 32px;

  width: var(--size);
  height: var(--size);
}

.size-xs {
  --size: 16px;
}

.size-s {
  --size: 24px;
}

.size-l {
  --size: 48px;
}

.size-xl {
  --size: 64px;
}

.size-xxl {
  --size: 72px;
}

.color-success {
  --svg-bg-color: var(--svg-success-color);
}

.color-warning {
  --svg-bg-color: var(--svg-warning-color);
}

.color-error {
  --svg-bg-color: var(--svg-error-color);
}

.color-info {
  --svg-bg-color: var(--svg-info-color);
}
